<template>
    <div class="company-info">
        <el-dialog 
            title="联系我们" 
            :visible.sync="dialogVisible" 
            width="60%" 
            :modal-append-to-body="false" 
            :append-to-body="true"
            :before-close="handleClose"
            custom-class="premium-dialog">
            <div class="info-content">
                <div class="content-wrapper">
                    <div class="info-container">
                        <!-- 左侧电话部分 -->
                        <section class="info-section phone-section">
                            <div class="section-header">
                                <div class="icon-wrapper">
                                    <i class="el-icon-phone"></i>
                                </div>
                                <h3>联系电话</h3>
                            </div>
                            <div class="section-body">
                                <div class="phone-numbers">
                                    <div class="phone-item">
                                        <div class="phone-main">
                                            <span class="label">手机</span>
                                            <a :href="'tel:' + phoneNumber" class="number mobile">{{ phoneNumber }}</a>
                                        </div>
                                        <div class="phone-sub">全天24小时为您服务</div>
                                    </div>
                                    <div class="divider"></div>
                                    <div class="phone-item">
                                        <div class="phone-main">
                                            <span class="label">座机</span>
                                            <a href="tel:0755-88608260" class="number">0755-88608260</a>
                                        </div>
                                        <div class="phone-sub">工作日 9:00-18:00</div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        
                        <!-- 右侧地址部分 -->
                        <section class="info-section address-section">
                            <div class="section-header">
                                <div class="icon-wrapper location-icon">
                                    <i class="el-icon-location"></i>
                                </div>
                                <h3>公司地址</h3>
                            </div>
                            <div class="section-body">
                                <div class="address-content">
                                    <p>深圳市光明区公明街道上村社区长春北路1A栋301</p>
                                    <div class="address-sub">欢迎您的来访</div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "CompanyInfo",
    data() {
        return {
            dialogVisible: false,
            phoneNumber: '19842675889'
        }
    },
    methods: {
        showDialog() {
            this.dialogVisible = true;
            this.$nextTick(() => {
                const modal = document.querySelector('.v-modal');
                if (modal) {
                    modal.style.zIndex = '2000';
                }
                const wrapper = document.querySelector('.el-dialog__wrapper');
                if (wrapper) {
                    wrapper.style.zIndex = '2001';
                }
            });
        },
        handleClose(done) {
            done();
        }
    }
};
</script>

<style lang="scss">
// .company-info {
    .premium-dialog {
        background: transparent;
        border-radius: 24px;
        overflow: hidden;
        backdrop-filter: blur(12px);
        -webkit-backdrop-filter: blur(12px);
        border: 1px solid rgba(255, 255, 255, 0.3);
        min-height: 300px;

        .el-dialog__header {
            background: linear-gradient(135deg, #1a6cd4 0%, #3388ff 100%);
            padding: 25px 40px;
            margin: 0;
            position: relative;
            backdrop-filter: blur(5px);
            border-bottom: 1px solid rgba(255, 255, 255, 0.15);
            
            .el-dialog__title {
                color: white;
                font-size: 1.8em;
                font-weight: 600;
                letter-spacing: 1.5px;
                text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            }

            .el-dialog__headerbtn {
                top: 25px;
                right: 30px;
                .el-dialog__close {
                    color: white;
                    font-size: 20px;
                    &:hover {
                        color: #fff;
                        opacity: 0.8;
                    }
                }
            }
        }

        .el-dialog__body {
            padding: 0;
            background: rgba(255, 255, 255, 0.9);
        }
    }

    .info-content {
        position: relative;
        overflow: hidden;

        .content-wrapper {
            position: relative;
            z-index: 1;
            padding: 30px;

            .info-container {
                display: flex;
                gap: 25px;
                min-height: 280px;
                width: 100%;
                
                .info-section {
                    flex: 0 0 calc(50% - 12.5px);
                    max-width: calc(50% - 12.5px);
                    display: flex;
                    flex-direction: column;

                    .section-header {
                        display: flex;
                        align-items: center;
                        margin-bottom: 25px;

                        .icon-wrapper {
                            width: 40px;
                            height: 40px;
                            border-radius: 12px;
                            background: linear-gradient(135deg, #1a6cd4 0%, #3388ff 100%);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin-right: 15px;
                            box-shadow: 0 4px 12px rgba(51, 136, 255, 0.2);

                            i {
                                color: white;
                                font-size: 20px;
                            }

                            &.location-icon {
                                background: linear-gradient(135deg, #27ae60 0%, #2ecc71 100%);
                                box-shadow: 0 4px 12px rgba(46, 204, 113, 0.2);
                            }
                        }

                        h3 {
                            margin: 0;
                            color: #2c3e50;
                            font-size: 20px;
                            font-weight: 600;
                            letter-spacing: 0.5px;
                        }
                    }

                    .section-body {
                        flex: 1;
                        background: white;
                        border-radius: 16px;
                        padding: 25px;
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

                        .phone-numbers {
                            .phone-item {
                                .phone-main {
                                    display: flex;
                                    align-items: center;
                                    flex-wrap: wrap;
                                    margin-bottom: 5px;

                                    .label {
                                        color: #7f8c8d;
                                        font-size: 16px;
                                        margin-right: 12px;
                                    }

                                    .number {
                                        color: #34495e;
                                        font-size: 20px;
                                        font-weight: 500;
                                        margin-right: 12px;
                                        text-decoration: none;

                                        &.mobile {
                                            color: #3388ff;
                                            font-size: 24px;
                                            font-weight: 600;
                                            letter-spacing: 1px;
                                        }

                                        &:hover {
                                            opacity: 0.8;
                                            text-decoration: underline;
                                        }
                                    }
                                }

                                .phone-sub {
                                    color: #95a5a6;
                                    font-size: 13px;
                                    margin-left: 70px;
                                }
                            }

                            .divider {
                                height: 1px;
                                background: linear-gradient(to right, rgba(51, 136, 255, 0.1), rgba(51, 136, 255, 0.05));
                                margin: 15px 0;
                            }
                        }

                        .address-content {
                            text-align: center;
                            
                            p {
                                color: #34495e;
                                line-height: 1.8;
                                font-size: 18px;
                                margin: 0;
                                letter-spacing: 0.5px;
                                font-weight: 500;
                            }

                            .address-sub {
                                color: #95a5a6;
                                font-size: 14px;
                                margin-top: 12px;
                                letter-spacing: 0.5px;
                            }
                        }
                    }
                }
            }
        }
    }
// }

@media screen and (max-width: 768px) {
    // .company-info {
        .premium-dialog {
            width: 92% !important;
        }

        .content-wrapper .info-container {
            flex-direction: column;
            gap: 20px;

            .info-section {
                flex: 0 0 100%;
                max-width: 100%;
                margin: 0;
            }
        }
    // }
}
</style>
